/* eslint-disable */
export default {
  logging: 'Registrando...',
  logCall: 'Registrar chamada',
  editLog: 'Editar log',
  select: 'Selecionar um registro correspondente',
  OnHold: 'Em espera',
  Ringing: 'Chamando',
  CallConnected: 'Chamada conectada',
  unknownUser: 'Usuário desconhecido',
  unknownNumber: 'Anônimo',
  unavailable: 'Indisponível',
  viewDetails: 'Exibir detalhes',
  addEntity: 'Criar novo',
  addLog: 'Log',
  text: 'Texto',
  call: 'Chamada',
  addContact: 'Adicionar contato',
  missedCall: 'Perdida',
  inboundCall: 'Entrada',
  outboundCall: 'Saída',
  from: 'De',
  to: 'Para',
  hangup: 'Desligar',
  accept: 'Atender',
  toVoicemail: 'Para caixa postal',
  anonymous: 'Anônimo',
  mergeToConference: 'Mesclar com chamada ativa',
  hold: 'Colocar em espera',
  unhold: 'Liberar',
  transfer: 'Transferir',
  reject: 'Rejeitar',
  switchCall: 'Alternar chamada para este aplicativo',
  callSwitch: 'Alternância de chamadas',
  comfirmContext:
    'Você está em uma chamada ativa com {displayName}. Gostaria de continuar a chamada neste dispositivo?',
  comfirmCancelButton: 'Cancelar',
  comfirmOKButton: 'Alternar',
  ignore: 'Ignorar',
  holdAndAnswer: 'Colocar em espera e atender',
} as const;

// @key: @#@"logging"@#@ @source: @#@"Logging..."@#@
// @key: @#@"logCall"@#@ @source: @#@"Log Call"@#@
// @key: @#@"editLog"@#@ @source: @#@"Edit Log"@#@
// @key: @#@"select"@#@ @source: @#@"Select a matching record"@#@
// @key: @#@"OnHold"@#@ @source: @#@"On Hold"@#@
// @key: @#@"Ringing"@#@ @source: @#@"Ringing"@#@
// @key: @#@"CallConnected"@#@ @source: @#@"Call Connected"@#@
// @key: @#@"unknownUser"@#@ @source: @#@"Unknown User"@#@
// @key: @#@"unknownNumber"@#@ @source: @#@"Anonymous"@#@
// @key: @#@"unavailable"@#@ @source: @#@"Unavailable"@#@
// @key: @#@"viewDetails"@#@ @source: @#@"View Details"@#@
// @key: @#@"addEntity"@#@ @source: @#@"Create New"@#@
// @key: @#@"addLog"@#@ @source: @#@"Log"@#@
// @key: @#@"text"@#@ @source: @#@"Text"@#@
// @key: @#@"call"@#@ @source: @#@"Call"@#@
// @key: @#@"addContact"@#@ @source: @#@"Add Contact"@#@
// @key: @#@"missedCall"@#@ @source: @#@"Missed"@#@
// @key: @#@"inboundCall"@#@ @source: @#@"Inbound"@#@
// @key: @#@"outboundCall"@#@ @source: @#@"Outbound"@#@
// @key: @#@"from"@#@ @source: @#@"From"@#@
// @key: @#@"to"@#@ @source: @#@"To"@#@
// @key: @#@"hangup"@#@ @source: @#@"Hang up"@#@
// @key: @#@"accept"@#@ @source: @#@"Answer"@#@
// @key: @#@"toVoicemail"@#@ @source: @#@"To Voicemail"@#@
// @key: @#@"anonymous"@#@ @source: @#@"Anonymous"@#@
// @key: @#@"mergeToConference"@#@ @source: @#@"Merge with active call"@#@
// @key: @#@"hold"@#@ @source: @#@"Hold"@#@
// @key: @#@"unhold"@#@ @source: @#@"Unhold"@#@
// @key: @#@"transfer"@#@ @source: @#@"Transfer"@#@
// @key: @#@"reject"@#@ @source: @#@"Reject"@#@
// @key: @#@"switchCall"@#@ @source: @#@"Switch Call to this app"@#@
// @key: @#@"callSwitch"@#@ @source: @#@"Call Switch"@#@
// @key: @#@"comfirmContext"@#@ @source: @#@"You're currently on an active call with {displayName}. Would you like to continue the call on this device?"@#@
// @key: @#@"comfirmCancelButton"@#@ @source: @#@"Cancel"@#@
// @key: @#@"comfirmOKButton"@#@ @source: @#@"Switch"@#@
// @key: @#@"ignore"@#@ @source: @#@"Ignore"@#@
// @key: @#@"holdAndAnswer"@#@ @source: @#@"Hold & Answer"@#@
